// src/lib/ai-adapter.js — Supabase Edge Function (Gemini proxy) met localStorage-cache op SHA-256(prompt).

async function aiCacheKey(prompt) {
  const buf = new TextEncoder().encode(prompt);
  const hash = await crypto.subtle.digest("SHA-256", buf);
  return "ai-cache:" + Array.from(new Uint8Array(hash))
    .map(b => b.toString(16).padStart(2, "0")).join("");
}

// Pakt een leesbare melding uit een (mogelijk geneste) Gemini-foutbody.
// Edge function wraps de upstream-error als { error: "<JSON-string>" } met HTTP 502.
function parseAiError(raw, fallback) {
  if (!raw) return fallback;
  if (typeof raw !== "string") raw = String(raw);
  try {
    const inner = JSON.parse(raw);
    const msg = inner?.error?.message || inner?.message;
    if (msg) return msg;
  } catch { /* niet geneste JSON, neem ruwe string */ }
  return raw;
}

export const claude = {
  async complete(prompt, opts = {}) {
    const key = await aiCacheKey(prompt);
    const cached = localStorage.getItem(key);
    if (cached !== null) return cached;

    const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
    const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;
    let res;
    try {
      res = await fetch(`${supabaseUrl}/functions/v1/ai`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${anonKey}`,
          "apikey": anonKey,
        },
        body: JSON.stringify({ prompt }),
        signal: opts.signal,
      });
    } catch (netErr) {
      if (netErr.name === "AbortError") throw netErr;
      const msg = `Netwerkfout: ${netErr.message || "geen verbinding"}`;
      window.__lastAiError = msg;
      throw new Error(msg);
    }

    if (!res.ok) {
      let detail;
      try {
        const body = await res.json();
        detail = parseAiError(
          body?.error ?? body?.message ?? body?.msg,
          `Server gaf ${res.status} terug`
        );
      } catch {
        detail = `Server gaf ${res.status} terug`;
      }
      window.__lastAiError = detail;
      throw new Error(detail);
    }

    const { text, error } = await res.json();
    if (error) {
      const msg = parseAiError(error, "Onbekende fout van de digitale assistent");
      window.__lastAiError = msg;
      throw new Error(msg);
    }

    try { localStorage.setItem(key, text); } catch { /* quota full → skip */ }
    return text;
  },
};
